const ICON_HALF_SIZE = 36;
const SIZER = 20;
const ANIMATION_DURATION = 500;

const config = {
  desktop: {
    0: [
      { item: 1, pos: 'right-bottom', delay: 0 },
      { item: 6, pos: 'bottom-left', delay: 0 },
    ],
    1: [{ item: 2, pos: 'right-top', delay: 350 }],
    2: [
      { item: 3, pos: 'right-top', delay: 700 },
      { item: 7, pos: 'left-bottom-far', delay: 700 },
    ],
    3: [
      { item: 9, pos: 'bottom-right', delay: 1050 },
      { item: 8, pos: 'left-bottom-far', delay: 1450 },
    ],
    4: [
      { item: 5, pos: 'right-top', delay: 500 },
      { item: 5, pos: 'right-bottom', delay: 500 },
    ],
    6: [{ item: 7, pos: 'right-bottom', delay: 350 }],
    7: [{ item: 8, pos: 'right-bottom', delay: 700 }],
    8: [{ item: 9, pos: 'right-bottom', delay: 1050 }],
  },

  tablet: {
    0: [
      { item: 1, pos: 'right-bottom', delay: 0 },
      { item: 3, pos: 'left-bottom-far', delay: 0 },
    ],
    1: [{ item: 5, pos: 'bottom-right', delay: 350 }],
    2: [
      { item: 3, pos: 'right-top', delay: 700 },
      { item: 6, pos: 'bottom-left', delay: 700 },
    ],
    3: [{ item: 4, pos: 'right-bottom', delay: 1050 }],
    5: [{ item: 8, pos: 'left-bottom-far', delay: 1050 }],
    6: [
      { item: 7, pos: 'right-top', delay: 1050 },
      { item: 7, pos: 'right-bottom', delay: 1050 },
    ],
    7: [
      { item: 8, pos: 'right-top', delay: 1400 },
      { item: 8, pos: 'right-bottom', delay: 1400 },
    ],
    8: [
      { item: 9, pos: 'right-top', delay: 1750 },
      { item: 9, pos: 'right-bottom', delay: 1750 },
    ],
  },
  mobile: {
    0: [{ item: 1, pos: 'right-top', delay: 0 }],
    1: [{ item: 2, pos: 'left-bottom-far', delay: 350 }],
    2: [
      { item: 3, pos: 'right-bottom', delay: 700 },
      { item: 4, pos: 'bottom-left', delay: 700 },
    ],
    3: [{ item: 5, pos: 'bottom-right', delay: 1050 }],
    5: [{ item: 6, pos: 'left-bottom-far', delay: 1400 }],
    6: [
      { item: 7, pos: 'right-bottom', delay: 1750 },
      { item: 8, pos: 'bottom-left', delay: 1750 },
    ],
    8: [
      { item: 9, pos: 'right-top', delay: 2100 },
      { item: 9, pos: 'right-bottom', delay: 2100 },
    ],
  },
};

const getScreenSize = () => {
  const width = window.innerWidth;

  if (width > 1024) {
    return 'desktop';
  }
  if (width > 767) {
    return 'tablet';
  }

  return 'mobile';
};

const lerp = (v0, v1, t) => {
  return (1.0 - t) * v0 + t * v1;
};

const drawBezierSplit = (ctx, x0, y0, x1, y1, x2, y2, t0, t1) => {
  ctx.beginPath();

  if (t0 === 0.0 && t1 === 1.0) {
    ctx.moveTo(x0, y0);
    ctx.quadraticCurveTo(x1, y1, x2, y2);
  } else if (t0 !== t1) {
    let t00 = t0 * t0;
    let t01 = 1.0 - t0;
    let t02 = t01 * t01;
    let t03 = 2.0 * t0 * t01;

    const nx0 = t02 * x0 + t03 * x1 + t00 * x2;
    const ny0 = t02 * y0 + t03 * y1 + t00 * y2;

    t00 = t1 * t1;
    t01 = 1.0 - t1;
    t02 = t01 * t01;
    t03 = 2.0 * t1 * t01;

    const nx2 = t02 * x0 + t03 * x1 + t00 * x2;
    const ny2 = t02 * y0 + t03 * y1 + t00 * y2;

    const nx1 = lerp(lerp(x0, x1, t0), lerp(x1, x2, t0), t1);
    const ny1 = lerp(lerp(y0, y1, t0), lerp(y1, y2, t0), t1);

    ctx.moveTo(nx0, ny0);
    ctx.quadraticCurveTo(nx1, ny1, nx2, ny2);
  }

  ctx.stroke();
  ctx.closePath();
};

const animatePathDrawing = (ctx, x0, y0, x1, y1, x2, y2, duration) => {
  let start = null;

  const step = function d(timestamp) {
    if (start === null) start = timestamp;

    const delta = timestamp - start;
    const progress = Math.min(delta / duration, 1);

    drawBezierSplit(ctx, x0, y0, x1, y1, x2, y2, 0, progress);

    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};

const drawBezier = (
  ctx,
  { startPointX, startPointY, endPointX, endPointY, cp2x, cp2y, delay },
) => {
  ctx.save();
  ctx.strokeStyle = '#000';
  ctx.lineWidth = 1;
  ctx.beginPath();

  setTimeout(() => {
    animatePathDrawing(
      ctx,
      startPointX,
      startPointY,
      cp2x,
      cp2y,
      endPointX,
      endPointY,
      ANIMATION_DURATION,
    );
  }, delay);

  ctx.stroke();
  ctx.restore();
};

const rightTop = (ctx, itemRect, itemToConnectRect, wrapperRect, delay) => {
  const startPointX =
    itemRect.x - wrapperRect.x + itemRect.width / 2 + ICON_HALF_SIZE + SIZER;
  const startPointY = itemRect.y - wrapperRect.y + ICON_HALF_SIZE;

  const endPointX =
    itemToConnectRect.x -
    wrapperRect.x +
    (itemToConnectRect.width - ICON_HALF_SIZE * 2) / 2 -
    SIZER;
  const endPointY = startPointY;

  drawBezier(ctx, {
    startPointX,
    startPointY,
    endPointX,
    endPointY,
    cp2x: (startPointX + endPointX) / 2,
    cp2y: itemToConnectRect.y - wrapperRect.y + SIZER,
    delay,
  });
};

const rightBottom = (ctx, itemRect, itemToConnectRect, wrapperRect, delay) => {
  const startPointX =
    itemRect.x - wrapperRect.x + itemRect.width / 2 + ICON_HALF_SIZE + SIZER;
  const startPointY = itemRect.y - wrapperRect.y + itemRect.height - SIZER;

  const endPointX =
    itemToConnectRect.x -
    wrapperRect.x +
    (itemToConnectRect.width - ICON_HALF_SIZE * 2) / 2 -
    SIZER;
  const endPointY = startPointY;

  drawBezier(ctx, {
    startPointX,
    startPointY,
    endPointX,
    endPointY,
    cp2x: (startPointX + endPointX) / 2,
    cp2y: itemToConnectRect.y - wrapperRect.y + itemToConnectRect.height,
    delay,
  });
};

const bottomLeft = (ctx, itemRect, itemToConnectRect, wrapperRect, delay) => {
  const startPointX = itemRect.x - wrapperRect.x + ICON_HALF_SIZE - SIZER;
  const startPointY =
    itemRect.y - wrapperRect.y + itemRect.height - ICON_HALF_SIZE + SIZER;

  const endPointX = startPointX;
  const endPointY = itemToConnectRect.y - wrapperRect.y + ICON_HALF_SIZE;

  drawBezier(ctx, {
    startPointX,
    startPointY,
    endPointX,
    endPointY,
    cp2x: itemToConnectRect.x - wrapperRect.x - ICON_HALF_SIZE + SIZER,
    cp2y: itemToConnectRect.y - wrapperRect.y - ICON_HALF_SIZE,
    delay,
  });
};

const bottomRight = (ctx, itemRect, itemToConnectRect, wrapperRect, delay) => {
  const startPointX = itemRect.x - wrapperRect.x + itemRect.width - SIZER;
  const startPointY =
    itemRect.y - wrapperRect.y + itemRect.height - ICON_HALF_SIZE + SIZER;

  const endPointX = startPointX;
  const endPointY = itemToConnectRect.y - wrapperRect.y + ICON_HALF_SIZE;

  drawBezier(ctx, {
    startPointX,
    startPointY,
    endPointX,
    endPointY,
    cp2x: itemToConnectRect.x - wrapperRect.x + itemRect.width + SIZER,
    cp2y: itemToConnectRect.y - wrapperRect.y - ICON_HALF_SIZE,
    delay,
  });
};

const leftBottomFar = (
  ctx,
  itemRect,
  itemToConnectRect,
  wrapperRect,
  delay,
) => {
  const startPointX = itemRect.x - wrapperRect.x + itemRect.width / 2;
  const startPointY =
    itemRect.y - wrapperRect.y + itemRect.height - ICON_HALF_SIZE + SIZER * 2;

  const endPointX = itemToConnectRect.x - wrapperRect.x + itemRect.width / 2;
  const endPointY = itemToConnectRect.y - wrapperRect.y - SIZER;

  drawBezier(ctx, {
    startPointX,
    startPointY,
    endPointX: (startPointX + endPointX) / 2,
    endPointY: (startPointY + endPointY) / 2,
    cp2x: startPointX,
    cp2y: endPointY - SIZER * 2,
    delay,
  });

  drawBezier(ctx, {
    startPointX: (startPointX + endPointX) / 2,
    startPointY: (startPointY + endPointY) / 2,
    endPointX,
    endPointY,
    cp2x: endPointX,
    cp2y: endPointY - SIZER,
    delay: delay + ANIMATION_DURATION,
  });
};

const animations = {
  'right-top': rightTop,
  'right-bottom': rightBottom,
  'bottom-left': bottomLeft,
  'bottom-right': bottomRight,
  'left-bottom-far': leftBottomFar,
};

document.addEventListener('DOMContentLoaded', () => {
  const canvases = document.querySelectorAll('.anim_pathways__canvas');

  if (!canvases.length) {
    return;
  }

  const observer = new IntersectionObserver(
    async (entries, _instance) => {
      // eslint-disable-next-line no-restricted-syntax
      for await (const entry of entries) {
        const canvas = entry.target;

        if (entry.isIntersecting) {
          const wrapper = canvas.closest('.inner__container');
          const wrapperRect = wrapper.getBoundingClientRect();
          canvas.width = wrapperRect.width * 3;
          canvas.height = wrapperRect.height * 3;

          const ctx = canvas.getContext('2d');
          ctx.scale(3, 3);

          const items = document.querySelectorAll('.anim_pathways--item');

          items.forEach((item, index) => {
            const itemRect = item.getBoundingClientRect();
            if (!config[getScreenSize()][index]) {
              return;
            }

            config[getScreenSize()][index].forEach((itemConfig) => {
              const itemToConnect = document.querySelector(
                `.anim_pathways--item[data-index='${itemConfig.item}']`,
              );

              const itemToConnectRect = itemToConnect.getBoundingClientRect();

              animations[itemConfig.pos](
                ctx,
                itemRect,
                itemToConnectRect,
                wrapperRect,
                itemConfig.delay,
              );
            });
          });
        }
      }
    },
    { threshold: 0.2 },
  );

  Array.from(canvases).forEach((item) => observer.observe(item));
});
